import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { useAuth } from "../../../contexts/auth-context";
import MaxWidthContainer from "../../../components/UI/MaxWidthContainer/MaxWidthContainer";
import Page from "../../page-layout";
import ProfileInfo from "./components/profile-info";
import OrderHistory from "./components/order-history";
import ContactUs from "./components/contact-us";
import Additional from "./components/additional";
import Collections from "./components/Collections";
import classNames from "classnames/bind";
import styles from "./MyAccountParhato2.module.scss";
import { BackButton } from "@core/components";
import ToggleActiveModule from "../../../components/ToggleActiveModule";
import PullToRefresh from "../../../parhato2/src/entities/pullToRefresh";
import { useConfig } from "../../../providers/config";

const cx = classNames.bind(styles);

const MyAccountParhato2 = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { user } = useAuth();
  const config = useConfig();

  if (!user) {
    history.replace("/auth");
    return null;
  }

  return (
    <Page>
      <Page.Header className="flex items-center justify-start h-16 mt-[env(safe-area-inset-top)]">
        <MaxWidthContainer classList="flex justify-between items-center bg-white py-2.5 pl-2.5">
          <BackButton />
          {config?.isToggleSwitchModuleEnabled && (
            <ToggleActiveModule isViewDescription={false} isViewPopover containerClassName="pr-2.5" />
          )}
        </MaxWidthContainer>
      </Page.Header>

      <Page.Content scrollEvents>
        <PullToRefresh />
        <MaxWidthContainer classList={cx("myAccountContainer, flex flex-col gap-4 px-[0.75rem] pb-24")}>
          <div className=" lg:flex h-full w-full justify-between gap-4 lg:mb-2">
            <div className="flex flex-col justify-between w-full lg:h-[13rem] gap-2 mb-4 lg:mb-0">
              <div className=" lg:block lg:mb-0">
                <span className="font-bold text-[1.0625rem]">{t("My Informaion")}</span>
              </div>
              <ProfileInfo />
            </div>
            <div className="w-full lg:h-full">
              <OrderHistory />
            </div>
          </div>
          <div className=" lg:flex h-full w-full justify-between gap-4 lg:h-[18rem]">
            <div className="w-full mb-4 lg:mb-0">
              <Collections />
            </div>

            <div className="flex flex-col w-full justify-between">
              <ContactUs />
              {config.isAdditionalPageEnabled && <Additional />}
            </div>
          </div>
        </MaxWidthContainer>
      </Page.Content>
    </Page>
  );
};

export default MyAccountParhato2;
